// Column definitions for the Users list in settings

export default {
    defaultSortField: 'name',
    defaultSortOrder: 'asc',
    rearrangeCols: false,
    isDetailed: false,
    isCheckable: false,
    stickeyHeaders: true,
    toolBar: {
        buttons: [
            {
                event: 'openActivityHistory',
                icon: 'icon-activityhistory',
                isLine: true,
                tooltip: 'View Activity History',
            },
            {
                event: 'addNew',
                icon: 'icon-addnew',
                isLine: true,
                tooltip: 'Create New User',
                permissionModule: 'app&projects',
                permissionType: 'alterMember',
            },{
                event: 'excelImport',
                icon: 'icon-importexcel',
                isLine: true,
                tooltip: 'Import Users from Excel',
                permissionModule: 'app&projects',
                permissionType: 'alterMember',
            },

        ],
        bulkActions: () => { },
        showLicenseUsage: true,
    },
    fields: [{
        title: 'Name',
        name: 'field-generic-input',
        width: '152px',
        id: 'name',
        sortField: 'firstName',
        searchable: true,
        prop: 'fullName',
        sticky: true,
        defaultVisible: true,
        inputProps: {
            type: 'text',
        },
    },
    {
        title: 'Email',
        name: 'field-generic-input',
        width: '152px',
        id: 'email',
        sortField: 'email',
        prop: 'email',
        defaultVisible: true,
    },
    {
        title: 'Licensed User',
        name: 'licensedUser',
        width: '112px',
        id: 'licensedUser',
        prop: 'hasReservedLicense',
        defaultVisible: true,
        multiple: false,
        filterText: 'Licensed User',
        visible: true,
        searchable: true,
    },
    {
        title: 'Permission Group',
        name: 'field-generic-input',
        width: '248px',
        id: 'permissionGroup',
        prop: 'groupName',
        defaultVisible: true,
        filterText: 'Permission Group',
        visible: true,
        searchable: true,
    }, {
        title: 'Role',
        name: 'field-generic-input',
        width: '216px',
        id: 'role',
        prop: 'role',
        sortField: 'role',
        filterText: 'Role',
        defaultVisible: true,
        alwaysVisible: false,
        visible: true,
        searchable: true,
    }, {
        title: 'Add To New Projects',
        name: 'autoAdd',
        width: '112px',
        id: 'autoAdd',
        prop: 'autoAddUser',
        defaultVisible: true,
        multiple: false,
        filterText: 'Users',
        visible: true,
        searchable: true,
    }, {
        name: 'field-generic-input',
        sortField: 'mobilePhone',
        title: 'Mobile',
        id: 'mobile',
        prop: 'mobilePhone',
        width: '120px',
        alwaysVisible: true,
    }, {
        name: 'appVersion',
        title: 'App',
        id: 'app',
        width: '120px',
        alwaysVisible: true,
    }, {
        title: 'Status',
        name: 'field-generic-input',
        width: '72px',
        id: 'status',
        prop: '_statusForCompany',
        defaultVisible: true,
    }, {
        title: 'Actions',
        name: 'data-table-action-fields',
        id: 'action',
        hideFromChooser: true,
        alwaysVisible: true,
        sticky: true,
        width: '112px',
        thAttrs: () => ({ class: 'action-sticky' }),
        tdClass: 'action-sticky',
        permissionModule: 'app&projects',
        permissionKey: 'members',
        inputProps: {
            showEdit: false,
            options(user) {
                if (user.isSupportAccount) {
                    return [
                    ];
                }
                if (user._statusForCompany === 'Archived') {
                    return [
                        {
                            icon: '',
                            label: 'Reactivate User',
                            event: 'resendActivateUser',
                            permissionModule: 'app&projects',
                            alterDataKey: 'alterMember',
                        },
                    ];
                }
                if (user.activated) {
                    return [
                        {
                            icon: 'icon-bin',
                            label: 'Archive',
                            event: 'member-archive',
                            permissionModule: 'app&projects',
                            alterDataKey: 'alterMember',
                        },
                    ];
                }
                return [
                    {
                        icon: 'icon-email',
                        label: 'Resend Mail',
                        event: 'resendMail',
                        permissionModule: 'app&projects',
                        alterDataKey: 'alterMember',
                    }, {
                        icon: 'icon-bin',
                        label: 'Archive',
                        event: 'member-archive',
                        permissionModule: 'app&projects',
                        alterDataKey: 'alterMember',
                    },
                ];
            },
            groupButtons(rowData) {
                return [
                    {
                        icon: 'icon-edit',
                        event: 'editUser',
                        tooltip: rowData.isSupportAccount ? 'Edit Support Account (Disabled)' : 'Edit User',
                        disabled: rowData.isSupportAccount || rowData._statusForCompany === 'Archived',
                        permissionModule: 'app&projects',
                        alterDataKey: 'alterMember',
                    },
                ];
            },
        },
    },
    ]
}
